import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from '@alfresco/adf-core';

import { SafeHtmlPipe } from '../../pipes';
import { WKMessageDialogComponent } from './message.dialog';
import { WKDeleteDecoratorsDialogComponent } from './wk-delete-decorators-dialog';
import { WKExternalPasteWarningDialogComponent } from './wk-external-paste-warning-dialog';

const components = [
  WKMessageDialogComponent,
  WKDeleteDecoratorsDialogComponent,
  WKExternalPasteWarningDialogComponent,
];

@NgModule({
  imports: [CommonModule, CoreModule, SafeHtmlPipe],
  declarations: components,
  exports: components,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MessageSharedModule {}
